var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 77,
    viewBox: "0 0 54 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9744 4.6155C49.6951 5.00172 50.1429 5.86242 50.1429 7.09778V46.571C50.1429 48.9934 48.421 51.9387 46.2968 53.1499L11.6813 72.8865C10.6192 73.4921 9.65764 73.5494 8.96162 73.1526L1.26929 68.7667C1.96531 69.1635 2.92685 69.1062 3.98894 68.5006L38.6044 48.764C40.7287 47.5528 42.4506 44.6074 42.4506 42.1851V2.71187C42.4506 1.47651 42.0027 0.615803 41.282 0.229584L48.9744 4.6155Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96167 73.1524C8.26565 72.7556 7.83516 71.9046 7.83516 70.6934V31.2202C7.83516 28.7979 9.55714 25.8524 11.6813 24.6413L46.2968 4.90469C47.3377 4.31122 48.282 4.24429 48.9744 4.61536L41.2821 0.229447C40.5897 -0.141626 39.6454 -0.0746974 38.6045 0.518776L3.98899 20.2554C1.86481 21.4665 0.142822 24.412 0.142822 26.8343V66.3075C0.142822 67.5187 0.573319 68.3697 1.26934 68.7665L8.96167 73.1524Z",
    fill: "url(#paint0_linear_113_203905)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddii_113_203905)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7016,
    height: 48.2451,
    rx: 4.3859,
    transform: "matrix(0.868715 -0.495312 0 1 7.69287 26.7549)",
    fill: "#70B7DD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddiiii_113_203905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7086 51.8184C27.0458 52.7664 25.5714 53.283 24.2852 53.368C23.0062 53.441 21.9971 53.1128 21.2581 52.3835C20.5191 51.6543 20.1425 50.5441 20.1283 49.0532L25.4364 46.0267C25.4577 46.5575 25.6105 46.9525 25.8947 47.2118C26.1789 47.463 26.5662 47.5663 27.0565 47.5217C27.5468 47.4772 28.1046 47.2766 28.7299 46.9201C29.3552 46.5635 29.9059 46.124 30.382 45.6013C30.8652 45.0665 31.2418 44.4993 31.5119 43.8997C31.7819 43.2919 31.9133 42.6984 31.9062 42.119C31.9133 41.5315 31.7677 41.096 31.4692 40.8124C31.1708 40.5288 30.748 40.4174 30.2008 40.4782C29.6608 40.5349 29.0213 40.7739 28.2822 41.1953L26.1612 42.4047L26.1612 38.1263L28.2822 36.9169C28.9289 36.5482 29.4973 36.1025 29.9876 35.5799C30.4851 35.0532 30.8723 34.492 31.1494 33.8965C31.4266 33.2928 31.5616 32.7053 31.5545 32.1341C31.5616 31.5709 31.4443 31.1475 31.2027 30.8639C30.9683 30.5681 30.6378 30.4243 30.2115 30.4324C29.7922 30.4365 29.3055 30.5965 28.7512 30.9125C28.1686 31.2448 27.6392 31.6641 27.1631 32.1705C26.6941 32.6729 26.321 33.2178 26.0439 33.8053C25.7668 34.3928 25.6211 34.9742 25.6069 35.5495L20.5653 38.424C20.5795 36.9331 20.9419 35.4219 21.6525 33.8904C22.3631 32.3508 23.3295 30.9125 24.5517 29.5755C25.781 28.2345 27.1808 27.1163 28.7512 26.2209C30.3145 25.3295 31.6895 24.8575 32.8762 24.8049C34.0628 24.7522 34.9866 25.0763 35.6474 25.7772C36.3083 26.4701 36.6387 27.4931 36.6387 28.8463C36.6458 30.244 36.2443 31.6276 35.4343 32.997C34.6313 34.3624 33.5974 35.511 32.3326 36.4429L32.3326 36.6373C34.0238 35.8999 35.2993 35.7966 36.1591 36.3274C37.026 36.8541 37.4559 37.8852 37.4488 39.4207C37.4488 40.863 37.0757 42.356 36.3296 43.8997C35.5906 45.4311 34.5603 46.8937 33.2386 48.2874C31.924 49.669 30.414 50.846 28.7086 51.8184Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddii_113_203905",
    x: 5.03211,
    y: 1.63444,
    width: 48.1615,
    height: 74.8957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.88692,
    dy: 0.88692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.153
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.88692,
    dy: -0.88692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.88692
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_113_203905",
    result: "effect2_dropShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.88692,
    dy: 0.88692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.88692
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_113_203905",
    result: "effect3_dropShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_113_203905",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.177384,
    dy: -0.177384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.177384
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.177384,
    dy: 0.177384
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.177384
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_113_203905",
    result: "effect5_innerShadow_113_203905"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddiiii_113_203905",
    x: 19.2511,
    y: 23.9222,
    width: 19.0749,
    height: 30.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0487318,
    dy: -0.0487318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0487318
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0487318,
    dy: 0.0487318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0487318
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_113_203905",
    result: "effect2_dropShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_113_203905",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.877173,
    dy: 0.877173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.877173,
    dy: -0.877173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_113_203905",
    result: "effect4_innerShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.877173,
    dy: -0.877173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_113_203905",
    result: "effect5_innerShadow_113_203905"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.877173,
    dy: 0.877173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.730978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_113_203905",
    result: "effect6_innerShadow_113_203905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_203905",
    x1: 4.72266,
    y1: 73.2476,
    x2: 2.33824,
    y2: 2.91642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#71B8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AED6EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.6826dbb234904bee24306ff3678c0675.svg";
export { ForwardRef as ReactComponent };